var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.exercise_id,_vm._g(_vm._b({ref:"inner",tag:"component",attrs:{"context":_vm.context,"show_advanced":_vm.show_advanced,"customization":_vm.customization},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},'component',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }